module.exports = __webpack_public_path__ + "img/Pioneer-Tender-Application.e8551b18.jpg";